export default __webpack_public_path__ + "static/media/ticker.443879d4.svg";